<template>
  <div class="account_set_wrap_box" v-loading="loading">
    <div class="account_set_header">
      <h2>个人信息</h2>
    </div>
    <div class="account_set_content">
      <div class="person_info_student" v-if="userType==2||userType==3">
        <p><span>院校：</span><el-input :disabled="true" v-model="userInfoData.schoolName"></el-input></p>
        <p><span>账号：</span><el-input :disabled="true" v-model="userInfoData.accountNum"></el-input></p>
        <p><span>身份：</span><el-input :disabled="true" v-model="userInfoData.userTypeStr"></el-input></p>
        <p><span>学号：</span><el-input :disabled="true" v-model="userInfoData.studentNum"></el-input></p>
        <p><span>姓名：</span><el-input :disabled="true" v-model="userInfoData.userName"></el-input></p>
        <p><span>性别：</span><el-input :disabled="true" v-model="userInfoData.userSex"></el-input></p>
        <p><span>身份证号：</span><el-input :disabled="true" v-model="userInfoData.identityCard"></el-input></p>
        <p><span>入学年份：</span><el-input :disabled="true" v-model="userInfoData.enrollmentYear"></el-input></p>
        <p><span>教育层次：</span><el-input :disabled="true" v-model="userInfoData.educationalLevel"></el-input></p>
        <p>
          <span>省份：</span>
          <el-select v-model="userInfoData.Province" placeholder="请选择省份">
            <el-option v-for="(item,index) in provinceList" :label="item.cityName" :value="item.cityName" :key="index"></el-option>
          </el-select>
        </p>
        <p><span>城市：</span><el-input v-model="userInfoData.City"></el-input></p>
        <p><span>一级组织：</span><el-input :disabled="true" v-model="userInfoData.firstStructName"></el-input></p>
        <p><span>二级组织：</span><el-input :disabled="true" v-model="userInfoData.secondStructName"></el-input></p>
        <p><span>班级：</span><el-input :disabled="true" v-model="userInfoData.teachingClass"></el-input></p>
        <!-- <p><span>专业：</span><el-input :disabled="true" v-model="userInfoData.major"></el-input></p>
        <p><span>行政班：</span><el-input :disabled="true" v-model="userInfoData.teachingClass"></el-input></p> -->
      </div>
      <div  v-else-if="userType==1">
<!--        <p><span>院校：</span><el-input :disabled="true" v-model="userInfoData.schoolName"></el-input></p>-->
<!--        <p><span>账号：</span><el-input :disabled="true" v-model="userInfoData.accountNum"></el-input></p>-->
<!--        <p><span>身份：</span><el-input :disabled="true" v-model="userInfoData.userTypeStr"></el-input></p>-->
<!--        <p><span>姓名：</span><el-input v-model.trim="userInfoData.userName" maxlength="10"></el-input></p>-->
<!--        <p><span>工号：</span><el-input :disabled="true" v-model="userInfoData.studentNum"></el-input></p>-->
<!--        <p><span>所属组织：</span><el-input :disabled="true" v-model.trim="userInfoData.firstStructName"></el-input></p>-->
        <teacher-info ref="teacherInfo" v-model="userInfoInitData"></teacher-info>
      </div>
      <div class="person_info_admin" v-else>
        <p><span>院校：</span><el-input :disabled="true" v-model="userInfoData.schoolName"></el-input></p>
        <p><span>账号：</span><el-input :disabled="true" v-model="userInfoData.accountNum"></el-input></p>
        <p><span>身份：</span><el-input :disabled="true" v-model="userInfoData.userTypeStr"></el-input></p>
        <p><span>姓名：</span><el-input v-model.trim="userInfoData.userName" maxlength="10"></el-input></p>
        <p><span>所属组织：</span><el-input :disabled="true" v-model.trim="userInfoData.firstStructName"></el-input></p>
      </div>
      <el-button class="user_info_save" @click="submitForm">保 存</el-button>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
import * as api from '../../../../api/userApi'
import teacherInfo from '@/views/szrt_revision/new_educa_module/educa/components/teacherInfo.vue'
export default {
  inject: ['reload'],
  components:{
    teacherInfo
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (value) {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }else if(value==''){
        return callback(new Error('手机号码不能为空'));
      }else{
        callback();
      }
    };
    return {
      loading: true,
      userInfoData: {
        schoolName: '',
        accountNum: '',
        userType: '',
        userTypeStr: '',
        studentNum: '',
        userName: '',
        userSex: '',
        identityCard: '',
        major: '',
        educationalLevel: '',
        enrollmentYear: '',
        teachingClass: '',
        Province: '',
        City: '',
        firstStructName: "",
        secondStructName: ""
      },
      userType: sessionStorage.getItem('userType'),
      // userType: 1,
      provinceList:[
        {cityName:'北京'},{cityName:'天津'},{cityName:'河北'},{cityName:'山西'},{cityName:'内蒙古'},
        {cityName:'辽宁'},{cityName:'吉林'},{cityName:'黑龙江'},{cityName:'上海'},{cityName:'江苏'},
        {cityName:'浙江'},{cityName:'安徽'},{cityName:'福建'},{cityName:'江西'},{cityName:'山东'},
        {cityName:'河南'},{cityName:'湖北'},{cityName:'湖南'},{cityName:'广东'},{cityName:'广西'},
        {cityName:'海南'},{cityName:'重庆'},{cityName:'四川'},{cityName:'贵州'},{cityName:'云南'},
        {cityName:'西藏'},{cityName:'陕西'},{cityName:'甘肃'},{cityName:'青海'},{cityName:'宁夏'},
        {cityName:'新疆'},{cityName:'新疆生产建设兵团'}
      ],
      height: window.innerHeight,
      userInfoInitData:{}
    };
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo(){
      api.getUserInfo().then(rs=>{
        if(rs.code==0){
          this.userInfoInitData = rs.data
          this.userInfoData = {
            schoolName: rs.data.deptName,
            accountNum: rs.data.userName,
            userType: rs.data.userType,
            userTypeStr: rs.data.userTypeStr,
            studentNum: rs.data.studentNumberOrjobNumber,
            userName: rs.data.name,
            userSex: rs.data.sexStr,
            identityCard: rs.data.idCard,
            major: rs.data.profession,
            educationalLevel: rs.data.educationalLevel,
            enrollmentYear: rs.data.schoolDate,
            teachingClass: rs.data.teachingClass,
            Province: rs.data.province,
            City: rs.data.city,
            firstStructName: rs.data.firstStructName ? rs.data.firstStructName : '全机构',
            secondStructName: rs.data.secondStructName ? rs.data.secondStructName : '',
          }
          this.loading = false
        }else{
          this.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
   async submitForm() {
      let submitData = null
      if (String(this.userType) === '1'){
        submitData = await this.$refs.teacherInfo.submitForm();
      }
      let that = this
      let obj = {}
      if(that.userType==0||that.userType==1){
        obj = {
          name: that.userInfoData.userName,
          userType: that.userType
        }
        if (that.userType==1){
          obj = submitData
        }

        if(obj.name==''){
          this.$messageWarning('请输入姓名')
          return
        }
      }else{
        obj = {
          province: that.userInfoData.Province,
          city: that.userInfoData.City,
          userType: that.userType
        }
        if(obj.province==''){
          this.$messageWarning('请选择省份')
          return
        }
        if(obj.city==''){
          this.$messageWarning('请输入城市')
          return
        }
      }
      api.updateUserInfo(obj).then(rs=>{
        if(rs.code==0){
          this.$messageSuccess('保存成功')
          if(obj.userType==0||obj.userType==1){
            sessionStorage.setItem('loginName',obj.name)
          }
          this.reload()
        }else{
          this.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.account_set_wrap_box {
  width: 100%;
  height: 100%;
  .account_set_header {
    height: 56px;
    background: #FFFFFF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h2{
      font-size: 20px;
      font-weight: 600;
      color: #0F0D11;
      position: relative;
      padding-left: 20px;
      &::after{
        content: "";
        position: absolute;
        width: 4px;
        height: 24px;
        background: #1890FF;
        border-radius: 0px 7px 7px 0px;
        left: 0;
      }
    }
  }
  /deep/ .account_set_content{
    height: calc(100% - 65px);
    background: #FFFFFF;
    border-radius: 4px;
    margin-top: 8px;
    padding: 0 24px;
    overflow-y: auto;
    .person_info_student,.person_info_teacher,.person_info_admin{
      width: 700px;
      display: flex;
      flex-wrap: wrap;
      p{
        width: 350px;
        height: 40px;
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        span{
          font-size: 14px;
          font-weight: 400;
          color: #0F0D11;
          width: 100px;
          text-align: right;
        }
        .el-input{
          flex: 1;
          .el-input__inner{
            width: 200px;
          }
        }
        .el-input.is-disabled .el-input__inner{
          color: #333;
        }
        &:first-child{
          width: 100%;
          .el-input__inner{
            width: 550px;
          }
        }
      }
    }
    .person_info_student{
      margin: 50px auto 0;
    }
    .person_info_teacher,.person_info_admin{
      margin: 100px auto 0;
    }
    .user_info_save{
      width: 100px;
      background:rgba(83,151,247,1);
      border-radius:4px;
      color: #fff;
      margin:0 calc(50% - 50px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/personalInformation.vue